import { ApexOptions } from 'apexcharts'
import { merge } from 'lodash'
import ReactApexChart from 'react-apexcharts'

//
import BaseOptionChart from './BaseOptionChart'

// ----------------------------------------------------------------------

interface ChartDonutProps {
  chartData: number[]
  options?: ApexOptions
  width?: number | string
}

export default function ChartDonut({ chartData, options, width }: ChartDonutProps) {
  const chartOptions = merge(BaseOptionChart(), {
    stroke: { show: false },
    legend: { horizontalAlign: 'center' },
    plotOptions: { pie: { donut: { size: '90%' } } },
    ...options,
  })

  return (
    <ReactApexChart type="donut" series={chartData} options={chartOptions} width={width || 400} />
  )
}
